import React from 'react';
import Switch from 'react-switch';

const CustomSwitch = (props) => {
  const {
    leftText,
    rightText,
    switchOffClassName,
    switchOnClassName,
  } = props;
  return (
    <Switch
      {...props}
      offColor="#d8dfe9"
      onColor="#d8dfe9"
      offHandleColor="#ffffff"
      onHandleColor="#ffffff"
      uncheckedIcon={
        <div className={switchOffClassName}>
          {rightText}
        </div>
      }
      checkedIcon={
        <div className={switchOffClassName}>
          {leftText}
        </div>
      }
      uncheckedHandleIcon={
        <div className={switchOnClassName}>
          {leftText}
        </div>
      }
      checkedHandleIcon={
        <div className={switchOnClassName}>
          {rightText}
        </div>
      }
    />
  );
};
export default CustomSwitch;
